export const IS_LOGGED_IN = window.passportInfo.isLoggedIn;
export function getPassportURL(action, fromComponent, nextPath) {
    const query = {
        next: nextPath ? `/form/#${nextPath}` : `/form/${window.location.hash}`,
        from: `universal-resume-${fromComponent}-${action}`,
        hl: 'ja',
        co: 'JP'
    };
    const queryStr = Object.keys(query)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
        .join('&');
    switch (action) {
        case 'signup':
            return `${window.passportInfo.signupURL}?${queryStr}`;
        case 'login':
            return `${window.passportInfo.loginURL}?${queryStr}`;
        case 'logout':
            return `${window.passportInfo.logoutURL}?${queryStr}`;
        case 'view':
            return `${window.passportInfo.viewURL}?${queryStr}`;
        default:
            throw new Error(`Unsupported passport action: ${action}`);
    }
}
